import * as constants from './constants';
import { fetchLogin } from '../../../utils/api';
import { fnEncrypt } from '../../../utils/secret';
import { getDateTime } from '../../../utils/date';
import { getUserInfo } from './util';

/**
 * 登录
 */
export const login = (params) => {
    return (dispatch, getState) => {
        dispatch({
            type: constants.LOGIN_REQUEST
        });
        fetchLogin({ ...params, noToken: true }).then(
            (res) => {
                // console.log(res);
                // 供应商 ID
                const iSupplierId = res.data.user.iSupplierId || 0;
                // 用户 ID
                const iUserId = res.data.user.iUserId || 0;
                // 用户账号
                const sUserAccount = res.data.user.sUserId || 0;
                // 用户姓名
                const sUserName = res.data.user.sName || '';
                // 用户头像
                const sPhotoPath = res.data.user.sPhoto || '';
                // 用户职位
                const sJobTitle = res.data.user.sPosition || '';
                // 用户公司
                const sCompanyName = res.data.sSupplierName || '';
                // 是否管理员
                const isAdmin = res.data.user.isAdmin || 0;
                // 是否可以查看所有候选人
                const isAllCandidate = res.data.user.isAllCandidate || 0;
                // 是否可以查看报表
                const isReport = res.data.user.isReport || 0;
                // 上次登录时间
                const sLastLoginDateTime = getDateTime(res.data.dtLastLogin) || '';

                const oUserInfo = {
                    iSupplierId,
                    iUserId,
                    sUserAccount,
                    sUserName,
                    sPhotoPath,
                    sJobTitle,
                    sCompanyName,
                    isAdmin,
                    isAllCandidate,
                    isReport,
                    sLastLoginDateTime
                };

                const encrypted = fnEncrypt(JSON.stringify(oUserInfo));
                localStorage.setItem('userinfo', encrypted);
                localStorage.setItem('token', res.data.token);

                dispatch({
                    type: constants.LOGIN_SUCCESS,
                    data: oUserInfo
                });
            },
            () => {
                dispatch({
                    type: constants.LOGIN_FAIL
                });
            }
        );
    };
};

/**
 * 退出
 */
export const logout = () => {
    return (dispatch, getState) => {
        localStorage.removeItem('token');
        localStorage.removeItem('userinfo');

        localStorage.removeItem('locationtags');
        localStorage.removeItem('industrytags');
        localStorage.removeItem('functiontags');
        localStorage.removeItem('jobleveltags');
        localStorage.removeItem('marrytags');
        localStorage.removeItem('degreetags');
        localStorage.removeItem('leavetimetags');
        localStorage.removeItem('userlist');

        dispatch({
            type: constants.LOGIN_LOGOUT
        });
    };
};

/**
 * 修改当前用户信息
 */
export const updateCurrentUserInfo = (params) => {
    return (dispatch, getState) => {
        let oUserInfo = getUserInfo();
        oUserInfo = {
            ...oUserInfo,
            ...params
        };

        const encrypted = fnEncrypt(JSON.stringify(oUserInfo));
        localStorage.setItem('userinfo', encrypted);

        dispatch({
            type: constants.CHANGE_USER_INFO,
            data: oUserInfo
        });
    };
};
